<template>
  <div class="dataBody" id="map">
    <div class="timeLineBox">
      <div class="playBtn">
        <img
          src="../../assets/paly.png"
          v-show="!isplaying"
          style="width:30px;height:30px"
          @click="palyHander"
          alt
        />
        <img
          src="../../assets/stop.png"
          v-show="isplaying"
          style="width:30px;height:30px"
          @click="palyHander"
          alt
        />
      </div>
      <div class="timeline">
        <el-slider
          height="40px"
          v-model="timeLineData"
          show-stops
          @change="timeChange"
          :marks="marks"
          :min="slidMindata"
          :max="slidMaxdata"
        ></el-slider>
      </div>
    </div>
    <div class="lengedBox">
      <div class="lengedBoxItem">{{unitText}}</div>
      <div
        class="lengedBoxItem2"
        :style="{'backgroundColor':getrgb(item)}"
        v-for="item in colorList"
      >
        <p class="mytext">{{item[0]}}</p>
      </div>
    </div>
    <div class="leftControllerBox">
      <div class="controllItemBox">
        <div>数据模式:</div>
        <div>
          <el-radio-group v-model="dataType" @change="dataAreachange" size="mini">
            <el-radio-button label="rcf">区域数据</el-radio-button>
            <el-radio-button label="glo">全球数据</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="controllItemBox">
        <div>起报日期:</div>
        <div>
          <el-date-picker
            size="mini"
            style="width:150px"
            v-model="statrTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
      <div class="controllItemBox">
        <div>起报时次:</div>
        <div>
          <el-select v-model="startFtime" style="width:150px" placeholder="请选择" size="mini">
            <el-option label="08" value="08:00:00"></el-option>
          </el-select>
        </div>
      </div>
      <div class="controllItemBox2">
        <div>要素选择:</div>
        <div style="margin-top:10px">
          <el-radio-group v-model="elementType" @change="elementTypeChange" size="mini">
            <div class="listGroupbox">
              <div v-for="item in elementList" style="margin-right:5px">
                <el-radio :label="item.name" style="margin-bottom:10px" border>{{item.title}}</el-radio>
              </div>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="controllItemBox2">
        <div>显示方式:</div>
        <div style="margin-top:10px">
          <el-radio-group v-model="showType" @change="showTypeChange" size="mini">
            <el-radio-button label="格点值">格点值</el-radio-button>
            <el-radio-button label="粒子动画" v-show="isShowValayer">粒子动画</el-radio-button>
            <el-radio-button
              label="风向杆"
              v-show="elementType=='uv_wind_10'||elementType=='uv_wind_100'"
            >风向杆</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="controllItemBox">
        <el-button type="primary" @click="getData">查询</el-button>
        <el-button type="info">自动播放</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { MapCreate, legendColor } from "../../map/mapImport.js";
import { unzip } from "../../map/zip.js";
import "leaflet-velocity/dist/leaflet-velocity.css";
import "leaflet-velocity/dist/leaflet-velocity";
import datajson from "../../map/test.json";
import wind1 from "../../assets/wind/wind1.png";
import wind2 from "../../assets/wind/wind2.png";
import wind3 from "../../assets/wind/wind3.png";
import wind4 from "../../assets/wind/wind4.png";
import wind5 from "../../assets/wind/wind5.png";
import wind6 from "../../assets/wind/wind6.png";
import wind7 from "../../assets/wind/wind7.png";
import wind8 from "../../assets/wind/wind8.png";
import wind9 from "../../assets/wind/wind9.png";
import wind10 from "../../assets/wind/wind10.png";
import wind11 from "../../assets/wind/wind11.png";
import wind12 from "../../assets/wind/wind12.png";
// import legendColor from "../../map/legendColor.json";
// import datajson2 from "../../map/test.json";
export default {
  data() {
    return {
      unitText: "m/s",
      startFtime: "08:00:00",
      isShowValayer: true,
      chooseGridData: null,
      tilePixelLayer: null,
      sldPlayTimeer: null,
      isplaying: false,
      timeLineData: 0,
      slidMindata: 0,
      slidMaxdata: 72,
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA"
          },
          label: this.$createElement("strong", "50%")
        }
      },
      map: null,
      showType: "格点值",
      dataType: "rcf",
      statrTime: "2024-07-01",
      elementType: "uv_wind_10",
      elementList: [
        {
          name: "uv_wind_10",
          title: "10m风",
          unit: "m/s"
        },
        {
          name: "uv_wind_100",
          title: "100m风",
          unit: "m/s"
        },
        {
          name: "uv_o",
          title: "洋流",
          unit: "m/s"
        },
        {
          name: "swell",
          title: "涌浪",
          unit: "m"
        },
        {
          name: "sst",
          title: "海表温度",
          unit: "℃"
        }
      ],
      colorList: legendColor["uv_wind_10"]
    };
  },
  mounted() {
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("map");
    let t = this;
    this.map.map.on("zoomend", () => {
      // console.log(this.map.map.getZoom());
      // console.log(parseInt(100 / this.map.map.getZoom()));
      // //console.log(map.getZoom());
      if (this.showType == "风向杆") {
        t.showMarkerLayer(
          this.chooseGridData.datas_s,
          this.chooseGridData.datas_d,
          parseInt(100 / this.map.map.getZoom()),
          this.chooseGridData
        );
      }
    });
  },
  destroyed() {
    console.log("beforeDestory");
    this.map.map.remove();
  },
  created() {
    this.colorList = legendColor["uv_wind_10"];
    console.log(this.colorList);
    this.getlineMarker(1, 5);
    this.getData();
  },
  methods: {
    dataAreachange(e) {
      if (e == "rcf") {
        this.slidMaxdata = 72;
        this.getlineMarker(1, 5);
        this.elementList = [
          {
            name: "uv_wind_10",
            title: "10m风",
            unit: "m/s"
          },
          {
            name: "uv_wind_100",
            title: "100m风",
            unit: "m/s"
          },
          {
            name: "uv_o",
            title: "洋流",
            unit: "m/s"
          },
          {
            name: "swell",
            title: "涌浪",
            unit: "m"
          },
          {
            name: "sst",
            title: "海表温度",
            unit: "℃"
          }
        ];
      } else {
        this.slidMaxdata = 12;
        this.getlineMarker(6, 1);
        this.elementList = [
          {
            name: "uv_wind_10",
            title: "10m风",
            unit: "m/s"
          },
          {
            name: "uv_wind_100",
            title: "100m风",
            unit: "m/s"
          },
          {
            name: "uv_o",
            title: "洋流",
            unit: "m/s"
          },
          {
            name: "swell",
            title: "涌浪",
            unit: "m"
          },
          {
            name: "sst",
            title: "海表温度",
            unit: "℃"
          },
          {
            name: "wlev",
            title: "海表高度",
            unit: "m"
          },
          {
            name: "t2",
            title: "2m气温",
            unit: "K"
          },
          {
            name: "mslp",
            title: "海平面气压",
            unit: "Pa"
          },
          {
            name: "rh",
            title: "相对湿度",
            unit: "%"
          },
          {
            name: "vis",
            title: "能见度",
            unit: "m"
          },
          {
            name: "precip",
            title: "累积降水",
            unit: "kg/m2"
          }
        ];
      }
    },
    elementTypeChange(e) {
      this.colorList = legendColor[e];
      this.unitText = this.elementList.filter(item => item.name == e)[0].unit;

      this.showType = "格点值";
      if (e == "uv_wind_10" || e == "uv_wind_100" || e == "uv_o") {
        this.isShowValayer = true;
      } else {
        this.isShowValayer = false;
      }
    },
    timeChange(e) {
      console.log(e);
      this.getData();
    },
    getlineMarker(index, maker) {
      let newdate = moment(
        `${this.statrTime} ${this.startFtime}`,
        "YYYY-MM-DD HH:mm:ss"
      ).format("HH:00");
      // ////console.log(newdate);
      let marker = {};
      for (let i = 0; i < this.slidMaxdata + 1; i++) {
        //// ////console.log(i);
        if (i % maker == 0) {
          marker[i] = {
            style: {
              color: "white"
            },
            label: moment(newdate, "HH:mm")
              .add(i * index, "h")
              .format("HH:mm")
          };
        }
      }
      // ////console.log(marker);
      this.marks = marker;
    },
    palyHander() {
      this.isplaying = !this.isplaying;
      if (this.isplaying) {
        // this.isshownum = false;
        // this.isshownumchange(this.isshownum);
        this.sldPlayTimeer = setInterval(() => {
          if (this.timeLineData == 119) {
            this.timeLineData = 0;
          } else {
            this.timeLineData = this.timeLineData + 1;
          }

          // this.changeMapGrid();
        }, 1000);
      } else {
        clearInterval(this.sldPlayTimeer);
        this.sldPlayTimeer = null;
      }
    },
    getrgb(data) {
      //// ////console.log(data);
      //// ////console.log(`rgb(${data[1][0]},${data[1][1]},${data[1][2]})`);
      return `rgb(${data[1][0]},${data[1][1]},${data[1][2]})`;
    },
    // showMarkerLayer(){

    // },
    showMarkerLayer(mygetdata1, mygetdata2, zindex, data) {
      console.log(mygetdata1, mygetdata2, zindex, data);
      //console.log(1111);
      //console.log(data);
      console.log(mygetdata1);
      console.log(mygetdata2);
      // return;
      if (this.tilePixelLayer != null) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }

      let myNewdata = JSON.parse(JSON.stringify(mygetdata1));
      let myNewdata2 = JSON.parse(JSON.stringify(mygetdata2));
      // let boxData = []
      //console.log(myNewdata, myNewdata2);
      let ecBoxList = [];
      for (let i = 0; i < data.rows; i++) {
        let newlist = myNewdata.slice(i * data.cols, (i + 1) * data.cols);
        ecBoxList.push(newlist);
      }
      let ecBoxList2 = [];
      for (let i = 0; i < data.rows; i++) {
        let newlist = myNewdata2.slice(i * data.cols, (i + 1) * data.cols);
        ecBoxList2.push(newlist);
      }
      let nx = (data.right - data.left) / data.cols;
      let ny = (data.top - data.bottom) / data.rows;
      let top = data.top;
      let left = data.left;
      let makerList = [];
      for (let y = 0; y < data.rows; y += zindex) {
        for (let x = 0; x < data.cols; x += zindex) {
          //console.log(x, y);
          let windimg = wind1;
          if (ecBoxList[y][x] <= 0.2) {
            windimg = wind1;
          } else if (ecBoxList[y][x] <= 1.5) {
            windimg = wind2;
          } else if (ecBoxList[y][x] <= 3.3) {
            windimg = wind3;
          } else if (ecBoxList[y][x] <= 5.4) {
            windimg = wind4;
          } else if (ecBoxList[y][x] <= 7.9) {
            windimg = wind5;
          } else if (ecBoxList[y][x] <= 10.7) {
            windimg = wind6;
          } else if (ecBoxList[y][x] <= 13.8) {
            windimg = wind7;
          } else if (ecBoxList[y][x] <= 17.1) {
            windimg = wind8;
          } else if (ecBoxList[y][x] <= 20.7) {
            windimg = wind9;
          } else if (ecBoxList[y][x] <= 24.4) {
            windimg = wind9;
          } else if (ecBoxList[y][x] <= 28.4) {
            windimg = wind10;
          } else if (ecBoxList[y][x] <= 32.6) {
            windimg = wind11;
          } else if (ecBoxList[y][x] <= 36.9) {
            windimg = wind12;
          }
          //console.log(windimg);
          let markerIcon = L.divIcon({
            html: `<div class="maerktext" style='-moz-transform:rotate(${ecBoxList2[y][x]}deg);
                  -webkit-transform:rotate(${ecBoxList2[y][x]}deg);'><img src="${windimg}"></img></div>`, //marker标注
            className: "testBoxIcon",
            iconSize: [10, 10], //marker宽高
            iconAnchor: [10, 10] //文字标注相对位置
          });

          makerList.push(
            L.marker([top - ny * y, left + nx * x], {
              icon: markerIcon
            })
          );
        }
      }
      // //console.log(makerList);
      this.tilePixelLayer = L.layerGroup(makerList).addTo(this.map.map);
      // });
    },
    showGridLayer(data) {
      // console.log(data.datas_s);
      // return;
      let ledcolorList = JSON.parse(JSON.stringify(this.colorList));
      this.tilePixelLayer = L.tilePixelLayer({
        newData: data.datas_s ? data.datas_s : data.datas,
        data: data,
        gradient: ledcolorList
      });
      this.map.map.addLayer(this.tilePixelLayer);
    },
    showVelocityLayer(geidData) {
      datajson[0].header.numberPoints = geidData.data_u.length;
      datajson[1].header.numberPoints = geidData.data_u.length;

      datajson[0].header.nx = geidData.cols;
      datajson[0].header.ny = geidData.rows;
      datajson[0].header.la1 = geidData.top;
      datajson[0].header.la2 = geidData.bottom;
      datajson[0].header.lo1 = geidData.left;
      datajson[0].header.lo2 = geidData.right;

      datajson[1].header.nx = geidData.cols;
      datajson[1].header.ny = geidData.rows;
      datajson[1].header.la1 = geidData.top;
      datajson[1].header.la2 = geidData.bottom;
      // datajson[1].header.lo1 = geidData.left;
      datajson[1].header.lo1 = geidData.left;
      datajson[1].header.lo2 = geidData.right;
      datajson[1].header.dy = (geidData.top - geidData.bottom) / geidData.rows;
      datajson[1].header.dx = (geidData.right - geidData.left) / geidData.cols;
      datajson[0].data = geidData.data_u.map(item => {
        if (item == -9999) {
          item = 0;
        }
        return item;
      });
      datajson[1].data = geidData.data_v.map(item => {
        if (item == -9999) {
          item = 0;
        }
        return item;
      });
      console.log(datajson);

      this.tilePixelLayer = L.velocityLayer({
        displayValues: false, //是否显示当前鼠标移动位置，风场信息
        displayOptions: {
          //显示信息配置
          velocityType: "Global Wind",
          displayPosition: "bottomleft",
          displayEmptyString: "No wind data"
        },
        data: datajson, //数据  格式可参照
        maxVelocity: 15,
        minVelocity: 0,
        velocityScale: 0.01,
        particleMultiplier: 1 / 100,
        lineWidth: 2,
        colorScale: ["rgb(0, 143, 252)", "rgb(0, 193, 252)", "rgb(0, 252, 252)"]
      });
      this.map.map.addLayer(this.tilePixelLayer);
    },
    showTypeChange() {
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.showType == "格点值") {
        this.showGridLayer(this.chooseGridData);
      } else if (this.showType == "粒子动画") {
        this.showVelocityLayer(this.chooseGridData);
      } else {
        this.showMarkerLayer(
          this.chooseGridData.datas_s,
          this.chooseGridData.datas_d,
          parseInt(100 / this.map.map.getZoom()),
          this.chooseGridData
        );
      }
    },
    getNewData() {
      console.log(this.elementType);
    },
    getData() {
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      let formData = new FormData();
      formData.append(
        "para",
        `{"dateTime":"${this.statrTime} ${this.startFtime}","elements":"${this.elementType}","hour":"${this.timeLineData}","type":"${this.dataType}"}`
      );
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: "http://120.79.183.250:3095/grid/getGrid", // 接口地址
        data: formData
      })
        .then(res => {
          let geidData = JSON.parse(unzip(res.data.datas));
          console.log(geidData);

          this.chooseGridData = geidData;

          if (this.showType == "格点值") {
            this.showGridLayer(geidData);
          } else if (this.showType == "粒子动画") {
            this.showVelocityLayer(geidData);
          } else {
            this.showMarkerLayer(
              geidData.datas_s,
              geidData.datas_d,
              parseInt(100 / this.map.map.getZoom()),
              geidData
            );
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.dataBody {
  height: calc(100vh - 60px);
  width: 100vw;
  /* background-color: red; */
}
.dataTypeChooseBox {
  width: 50px;
  height: 300px;
  position: absolute;
  right: 10px;
  top: 100px;
  background-color: white;
  z-index: 999;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.leftControllerBox {
  /* height: 90vh; */
  width: 300px;
  background-color: #102d50b2;
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 999;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  border: 2px solid #3f9dfe;
}
.controllItemBox {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  margin-top: 20px;
}
.controllItemBox2 {
  width: 100%;
  /* height: 40px; */

  color: white;
  margin-top: 20px;
}
.listGroupbox {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.el-radio__label {
  color: white !important;
}
.lengedBox {
  height: 20px;
  /* width: 100px; */
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 999;
  /* background-color: red; */
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #3f9dfe;
  display: flex;
}
.lengedBoxItem {
  height: 20px;
  width: 50px;
  background-color: #3f9dfe;
  opacity: 0.9;
  text-align: center;
  line-height: 20px;
  color: white;
}
.lengedBoxItem2 {
  height: 20px;
  width: 30px;
  /* background-color: #3f9dfe; */
  opacity: 0.9;
  text-align: center;
  line-height: 20px;
}
.mytext {
  color: white;
  font-size: 12px;
  mix-blend-mode: difference;
}
.timeLineBox {
  height: 40px;
  width: 80vw;
  position: absolute;
  z-index: 999;
  bottom: 50px;
  left: 10vw;
  background-color: #102d50b2;
  border-radius: 20px;
  border: 1px solid #3f9dfe;
  display: flex;
  /* align-items: center; */
  padding: 0 30px;
}
.playBtn {
  width: 10%;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.timeline {
  width: 90%;
  position: relative;
  top: -10px;
}
</style>